export const BANNER_IMAGE_BLUR_PX = 50;
export const BANNER_IMAGE_HEIGHT_MD_PX = 472;
export const BANNER_IMAGE_HEIGHT_SM_XS_PX = 250;

export const BANNER_WIDTH = '100%';
export const BANNER_HEIGHT = {
    xs: `${BANNER_IMAGE_HEIGHT_SM_XS_PX}px`,
    sm: `${BANNER_IMAGE_HEIGHT_SM_XS_PX}px`,
    md: `${BANNER_IMAGE_HEIGHT_MD_PX}px`,
};
// The 3:2 banner would otherwise grow with the viewport (about 853px at 2560 wide).
export const BANNER_MAX_HEIGHT = {
    md: `${BANNER_IMAGE_HEIGHT_MD_PX}px`,
};
